import React, { Component } from "react";
import {
  DEFAULT_MAX_HARD_RELOADS,
  isChunkLoadFailureMessage,
  reloadWithCacheBustIfUnderMax,
} from "../../utils/chunkLoadRecovery";

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof window === "undefined") return;

    const max =
      this.props.maxReloadAttempts != null
        ? this.props.maxReloadAttempts
        : DEFAULT_MAX_HARD_RELOADS;

    // Reload on any error by default; stale chunks often surface as generic errors
    const preferReload =
      this.props.reloadOnAnyError !== false ||
      isChunkLoadFailureMessage(error && error.message);

    if (preferReload && reloadWithCacheBustIfUnderMax(max)) {
      return; // page is reloading — skip logging
    }

    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <h2>Something went wrong.</h2>;
    }
    return this.props.children;
  }
}
